import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {AppState, selectActivePublicationState} from '@store/app.states';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import * as activePublication from '@app/components/publications/create-publication/_store/active-publication.reducers';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {LoadPublication} from '@app/components/publications/create-publication/_store/active-publication.actions';
import {fuseAnimations} from '@fuse/animations';
import {getPublicationInfos} from '@app/components/publications/publication-sideBar/publication-sideBar.selectors';
import {UserContext} from '@models/user';
import {AuthService} from '@app/services/auth/auth.service';
import {ClonePublication, HideAppSideBarLinks} from '@app/components/publications/store/publications/publications.actions';
import {Router} from '@angular/router';

@Component({
    selector: 'app-publication-side-bar',
    templateUrl: './publication-sideBar.component.html',
    styleUrls: ['./publication-sideBar.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class PublicationSideBarComponent extends OnDestroyMixin implements OnInit {

  userContext: UserContext = this.authService.getContext();

  public getActivePublication$: Observable<activePublication.State> = this.store
    .pipe(
      select(selectActivePublicationState),
      distinctUntilChanged(),
      untilComponentDestroyed(this)
    );

  public pubInfoFromList: any = null;

  surveyIds: string[] = [];

  @Input()
  pubUuid: string;

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService,
    private authService: AuthService,
    public router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {

    //
    // On va la charger si elle n'est pas là :)
    //
    this.getActivePublication$.subscribe((data) => {
      if (((!data.datas) || (data.datas.uuid !== this.pubUuid)) && !data.uxInteractions.loading) {

        this.store.dispatch(new LoadPublication({uuid: this.pubUuid}));
      } else {
        if (data.uxInteractions.surveys.surveysList?.length > 0) {

          if (data.datas) {

            this.surveyIds = data.uxInteractions.surveys.surveysList
              .filter((a) => data.datas.surveys.ids.includes(a.surveyId))
              .map(s => s.surveyId.toString());

          }

        }
      }

    });

    this.store
      .pipe(
        select(getPublicationInfos),
        map((f) => f({uuid: this.pubUuid})),
        distinctUntilChanged(),
        untilComponentDestroyed(this),
      )
      .subscribe((data) => {
        this.pubInfoFromList = data;
      });

  }

  clonePublication(pubUuid) {
    this.store.dispatch(new ClonePublication({pubUuids: [pubUuid]}));
  }

  displayDashboard(uuid, isV2) {
    const url = `publications/dashboard${isV2 ? 'V2' : ''}/display/${uuid}`;
    console.log(url);
    if (isV2) {
      this.router.navigateByUrl(`publications/dashboardV2/display/${uuid}`).then(() => {
        this.closeSideBar();
      });
    } else {
      this.router.navigateByUrl(`publications/dashboard/display/${uuid}`).then(() => {
        this.closeSideBar();
      });
    }

  }

  closeSideBar() {
    this.store.dispatch(new HideAppSideBarLinks());
    this.cdr.markForCheck();
  }


}
